export const RECENT_TAG_OR_COMMIT = import.meta.env.VITE_RECENT_TAG_OR_COMMIT
